// pages from Sanity (e.g. /terms-of-use)

import { sanityClient, urlFor } from "../lib/Sanity";
import { PortableText } from "@portabletext/react";
import Head from "next/head";
import styles from "../styles/page.module.scss";
import Image from "next/image";

const ptComponents = {
  types: {
    image: ({ value }) => {
      if (!value?.asset?._ref) {
        return null;
      }
      return (
        <div className={styles.image}>
          <Image
            src={urlFor(value).url()}
            alt={value.alt || " "}
            width={800} 
            height={600}
            sizes="(max-width: 768px) 100vw, 800px"
            loading="lazy"
          />
        </div>
      );
    },
  },
};

export const getStaticPaths = async () => {
  const query = `*[_type == "page"]{
    _id,
    slug {
      current
    }
  }`;

  const pages = await sanityClient.fetch(query);
  const excludedPages = ["our-community"];
  const paths = pages
    .filter((page) => !excludedPages.includes(page.slug.current)) // Exclude specified pages
    .map((page) => ({
      params: {
        slug: page.slug.current,
      },
    }));

  return {
    paths,
    fallback: "blocking",
  };
};

export const getStaticProps = async ({ params }) => {
  const query = `*[_type == "page" && slug.current == $slug] [0]`;
  const page = await sanityClient.fetch(query, {
    slug: params?.slug,
  });

  if (!page) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      page,
    },
    revalidate: 60,
  };
};


export default function Page({ page }) {
  return (
    <>
      <Head>
        <title>{page.title}</title>
        <meta property="og:title" content={page.title} key="title" />
        <meta name="description" content={page.title} />
      </Head>

      <header className={styles.page}>
        <div className={styles.container}>
          <h1 className={styles.title}>{page.title}</h1>
          {page.mainImage && (
            <div className={styles.header_image}>
              <Image
                src={urlFor(page.mainImage).url()}
                alt={page.title}
                layout="fill"
                style={{objectFit: 'cover'}}
              />
            </div>
          )}
        </div>
      </header>

      <main className={styles.page}>
        <article className={styles.container}>
          <PortableText value={page.body} components={ptComponents} />
        </article>
      </main>
    </>
  );
}